import "../../css/description-component.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import { ContentState, convertToRaw, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import PropTypes from "prop-types";
import React from "react";
import { Editor } from "react-draft-wysiwyg";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { Button } from "@material-ui/core";
import { styles } from "./styles";
import CloudUploadIcon from "@material-ui/icons/CloudUploadRounded";
import CodeIcon from "@material-ui/icons/CodeRounded";
import Upload from "./selectUpload";
import Snackbar from "../snackbar";
import LabelForm from "../../partials/labelForm";
import EmbedCode from "./embedCode";
import Review from "./review";

class DescriptionComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: EditorState.createEmpty(),
    };
    this.onEditorStateChange = this.onEditorStateChange.bind(this);
  }
  componentDidMount() {
    this.props.onRef(this);
    let description = this.props.description;
    if (description) {
      let blocksFromHtml = htmlToDraft(description);
      let { contentBlocks, entityMap } = blocksFromHtml;
      let contentState = ContentState.createFromBlockArray(
        contentBlocks,
        entityMap
      );
      // let editorStateDefault = EditorState.createWithContent(contentState);
      this.setState({
        editorState: EditorState.createWithContent(contentState),
      });
    }
  }
  changeDescription(description) {
    let blocksFromHtml = htmlToDraft(description);
    let { contentBlocks, entityMap } = blocksFromHtml;
    let contentState = ContentState.createFromBlockArray(
      contentBlocks,
      entityMap
    );
    this.setState({ editorState: EditorState.createWithContent(contentState) });
  }
  reset() {
    this.setState({ editorState: EditorState.createEmpty() });
  }

  onEditorStateChange = (editorState) => {
    let { nameInput } = this.props;
    let _this = this;
    // this.setState({ editorState }, function () {
    //   _this.props.handleSubComponentChange(
    //     nameInput,
    //     draftToHtml(convertToRaw(editorState.getCurrentContent()))
    //   );
    // });
    this.setState({ editorState });
    this.props.handleSubComponentChange(
      nameInput,
      draftToHtml(convertToRaw(editorState.getCurrentContent()))
    );
  };
  uploadImageCallBackCustom = async (file) => {
    const response = await this.props.albumDispatch.uploadFile({
      file: file,
      prefix: "",
      code: this.props.serviceCode,
    });
    if (response.code !== 1) {
      this.mSnackbar.handleClick(checkCreateAlbum.message, "error");
      return;
    }
    return new Promise((resolve, reject) => {
      const reader = new FileReader(); // eslint-disable-line no-undef
      reader.onload = (e) =>
        resolve({ data: { link: response.data.imageUrl } });
      reader.onerror = (e) => reject(e);
      reader.readAsDataURL(file);
    });
  };
  uploadImage = () => {
    this.Upload.open();
  };
  updateHTML = (value) => {
    let blocksFromHtml = htmlToDraft(value);
    let { contentBlocks, entityMap } = blocksFromHtml;
    let contentState = ContentState.createFromBlockArray(
      contentBlocks,
      entityMap
    );
    // let editorStateDefault = EditorState.createWithContent(contentState);
    this.setState({ editorState: EditorState.createWithContent(contentState) });
  };
  embedCode = () => {
    const { editorState } = this.state;
    let html = null;
    if (editorState) {
      html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    }
    this.mEmbed.open(html);
  };
  reviewHTML = () => {
    const { editorState } = this.state;
    let html = null;
    if (editorState) {
      html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
      this.mReview.open(html);
    }
  };
  render() {
    const {
      classes,
      title,
      required,
      disabled = false,
      spacing = 3,
      t,
    } = this.props;
    const { editorState } = this.state;
    return (
      <Grid container spacing={spacing}>
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Review onRef={(id) => (this.mReview = id)} />

        <EmbedCode
          updateHTML={this.updateHTML}
          onRef={(id) => (this.mEmbed = id)}
        />
        <Upload onRef={(id) => (this.Upload = id)} copyLink={this.copyLink} />
        <Grid item xs={12} sm={12} className={classes.containerLabel}>
          <LabelForm required={required ? true : false} label={title} />
          <Button
            disabled={editorState ? false : true}
            onClick={this.reviewHTML}
          >
            {t("review")}
          </Button>
        </Grid>
        <Grid item xs={12} sm={12} className={classes.root}>
          <Editor
            readOnly={disabled}
            toolbarAlwaysVisible
            toolbarCustomButtons={[
              <div onClick={this.uploadImage}>
                <CloudUploadIcon className={classes.customIcon} />
              </div>,
              <div onClick={this.embedCode}>
                <CodeIcon className={classes.customIcon} />
              </div>,
            ]}
            editorState={editorState}
            wrapperClassName="wrapper-class"
            editorClassName={`editor-class ${classes.editorCss}`}
            toolbarClassName="toolbar-class"
            onEditorStateChange={this.onEditorStateChange}
            toolbar={{
              inline: { inDropdown: true },
              list: { inDropdown: true },
              textAlign: { inDropdown: true },
              link: { inDropdown: true },
              history: { inDropdown: true },
              image: {
                uploadCallback: this.uploadImageCallBackCustom,
                alt: { present: false, mandatory: false },
                previewImage: true,
                defaultSize: {
                  height: "auto",
                  width: "100%",
                },
              },
              options: [
                "inline",
                "blockType",
                "fontSize",
                "fontFamily",
                "list",
                "textAlign",
                "colorPicker",
                "link",
                "embedded" /*, 'emoji'*/,
                "image",
                "remove",
                "history",
              ],
            }}
          />
        </Grid>
      </Grid>
    );
  }
}

DescriptionComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
DescriptionComponent.defaultProps = {
  nameInput: "description",
};
const mapState = (state) => ({
  serviceCode: state.user.user.roleId.serviceCode,
  adminService: state.service.adminService,
});

const mapDispatch = (dispatch) => ({
  albumDispatch: dispatch.album,
  uploadDispatch: dispatch.upload,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(DescriptionComponent)
  )
);
